export const TransferItemAPITypes = {
  file: 'file',
  emptyDirectory: 'empty_directory',
};

export const TransferItemUITypes = {
  file: 'file',
  directory: 'directory',
};
